import { render, staticRenderFns } from "./Medicos.vue?vue&type=template&id=e4c34eaa&"
import script from "./Medicos.vue?vue&type=script&lang=js&"
export * from "./Medicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports